import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

interface NoPad {
  noPad?: 'bottom' | 'top' | 'both';
}
interface IPageSection {
  recessed?: boolean;
  noBorder?: boolean;
}

export const PageSectionWrapper = styled.div<IPageSection>`
  position: relative;
  padding: 0 ${layout.measurements.spacing050};

  &,
  :before,
  :after {
    ${p =>
      !p.noBorder &&
      !p.recessed &&
      css`
        border-bottom: 1px solid ${p.theme.lines.primary};
      `};
  }

  :before {
    position: absolute;
    left: -50vw;
    right: calc(-50vw + 355px);
    z-index: -1;
    content: '';
    height: 100%;

    /* Due to side scroll bug in Safari, left and right values are reset
    at certain breakpoints to prevent side scroll. This is a quick and dirty solution, and
     need to be fixed in a more sustainable way.  */

    @media screen and (max-width: 2030px) {
      left: calc(50% + 203px - 50vw);
      right: calc(50% - 135px - 50vw);
    }

    @media screen and (max-width: 1392px) {
      left: calc(50% + 36px - 50vw);
      right: calc(50% - 132px - 50vw);
    }

    @media screen and (max-width: 1200px) {
      left: calc(50% + 36px - 50vw);
      right: calc(50% + 36px - 50vw);
    }

    @media screen and (max-width: 1058px) {
      left: calc(50% + 15px - 50vw);
      right: calc(50% + 36px - 50vw);
    }

    @media screen and (max-width: 1024px) {
      left: -10px;
      right: 0px;
    }

    ${p =>
      !p.noBorder &&
      !p.recessed &&
      css`
        border-bottom: 1px solid ${p.theme.lines.primary};
      `};

    ${({ recessed, theme }) =>
      recessed &&
      css`
        background-color: ${theme.bg.quaternary};
      `};
  }
`;

export const PageSectionContent = styled.section<NoPad>`
  ${p => {
    if (p.noPad === 'bottom') {
      return css`
        padding-top: ${layout.measurements.spacing200};
        padding-bottom: 0;
        ${media.mediumUp` 
            padding-top: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'top') {
      return css`
        padding-bottom: ${layout.measurements.spacing200};
        padding-top: 0;
        ${media.mediumUp` 
          padding-bottom: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'both') {
      return css`
        padding: 0;
      `;
    }

    return css`
      padding: ${layout.measurements.spacing200} 0;
      ${media.mediumUp`
        padding: ${layout.measurements.spacing400} 0;
      `};
    `;
  }};

  :empty {
    display: none;
  }
`;
